<template>
  <div>

    <vs-popup title="Empresa" :active.sync="modal_company">
      <formulate-form name="dataform" autocomplete="off" @submit="formHandler" >
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Nombre</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <formulate-input class="w-full" v-model="company_selected.com_name" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>DNI</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <formulate-input class="w-full" v-model="company_selected.com_dni" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Dirección</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <formulate-input class="w-full" v-model="company_selected.com_address" />
          </div>
        </div>
        <!-- <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>com_phone</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <formulate-input class="w-full" v-model="company_selected.com_phone" />
          </div>
        </div> -->
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Email</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <formulate-input class="w-full" type="email" validation="required|email" v-model="company_selected.com_email" />
          </div>
        </div>
        <!-- <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Descr</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <formulate-input class="w-full" v-model="company_selected.com_description" />
          </div>
        </div> -->

        <FormulateInput type="submit">Guardar</FormulateInput >
      </formulate-form>
    </vs-popup>


    <vs-table stripe pagination max-items="5" search :data="companies">
      <template slot="header">
        <vs-button color="primary" type="border" icon-pack="feather" icon="icon-plus" @click="company_selected={ com_id : 0, com_name: '', com_dni: '', com_address: '', com_phone: '', com_email: '', com_description: ''}; modal_company=true" >Agregar</vs-button >
      </template>
      <template slot="thead">
        <vs-th>Nombre</vs-th>
        <vs-th>N° Identificación</vs-th>
        <vs-th>Dirección</vs-th>
        <!-- <vs-th>com_phone</vs-th> -->
        <vs-th>Email</vs-th>
        <!-- <vs-th>com_description</vs-th> -->
        <vs-th> Acciones</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">

          <vs-td :data="tr.com_name"> {{ tr.com_name }} </vs-td>
          <vs-td :data="tr.com_dni"> {{ tr.com_dni }} </vs-td>
          <vs-td :data="tr.com_address"> {{ tr.com_address }} </vs-td>
          <!-- <vs-td :data="tr.com_phone"> {{ tr.com_phone }} </vs-td> -->
          <vs-td :data="tr.com_email"> {{ tr.com_email }} </vs-td>
          <!-- <vs-td :data="tr.com_description"> {{ tr.com_description }} </vs-td> -->

          <vs-td>
              <vs-button radius color="warning" type="flat" icon-pack="feather" icon="icon-edit" @click="company_selected=tr; modal_company=true" ></vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import axios from '@/axios'
export default {
  data() {
    return {
      config: null,
      companies: [],
      company_selected: { com_id : 0, com_name: '', com_dni: '', com_address: '', com_phone: '', com_email: '', com_description: ''},
      modal_company: false,
    };
  },
  computed: {
    
  },
  mounted() {
    this.config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.accessToken,
        },
    }
    this.getCompanies()
  },
  methods: {
    getCompanies(){
        let me = this
        this.$vs.loading()
        axios
        .get(`auth/getCompanies`, this.config )
        .then(function (response) {
            me.companies = response.data.data
            me.$vs.loading.close()
        })
        .catch(function (error) {
            me.$vs.loading.close()
        })
    },
    formHandler(){
        let me = this
        this.$vs.loading()
        axios
        .post(`auth/saveCompany`, this.company_selected, this.config )
        .then(function (response) {
            me.company_selected = { com_id : 0, com_name: '', com_dni: '', com_address: '', com_phone: '', com_email: '', com_description: ''}
            me.modal_company = false
            me.getCompanies();
            me.$vs.loading.close()
        })
        .catch(function (error) {
            me.$vs.loading.close()
        })
    },
  },
};
</script>
